import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/grid.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';

var GridContainer = function (_a) {
  var children = _a.children;
  var bem = HoneyBem.init('grid-container', styles);
  return /*#__PURE__*/React__default__default.createElement("div", {
    className: bem.b()
  }, children);
};
GridContainer.propTypes = {
  children: PropTypes__default.node.isRequired
};

export { GridContainer as default };
